export interface ApiState {
  url: string;
}

const state: ApiState = { url: process.env.VUE_APP_API_URL };

const actions = {
  // eslint-disable-next-line
  setUrl: ({ commit }: any, url: string) => {
    commit('setUrl', url);
  },
};

const mutations = {
  setUrl(newState: ApiState, url: string): void {
    // eslint-disable-next-line no-param-reassign
    newState.url = url;
  },
};

const getters = {
  env: (s: ApiState) => {
    if (s.url.includes("localhost")) {
      return "Local";
    }
    if (s.url.includes("-qa.herokuapp.com")) {
      return "QA";
    }
    if (s.url.includes("bem-creative-api.herokuapp.com")) {
      return "";
    }
    if (s.url.includes("herokuapp.com")) {
      return "Review";
    }
    return "";
  },
};

export const api = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
